function HomeSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" 
      width="21" 
      height="21" 
      viewBox="0 0 42 42" 
      className="home-svg"
    >
      <path fill="currentcolor" d="M41.511 19.63L23.092.977a2.781 2.781 0 00-.559-.482C22.047.167 21.531 0 21 0c-.573 0-1.102.169-1.574.5a2.4 2.4 0 00-.553.518L.488 19.632A1.683 1.683 0 000 20.824c0 .45.173.873.488 1.19.579.59 1.424.421 2.23-.392l1.235-1.253L21.05 3.38l.104.105L39.283 21.77c.555.373 1.054.572 1.459.572.3 0 .552-.108.77-.327A1.69 1.69 0 0042 20.824c0-.45-.173-.875-.489-1.194zm-6.87-.964a1.4 1.4 0 00-1.385 1.4v17.4c0 .951-.764 1.724-1.704 1.724H27.33v-9.7c0-2.384-1.913-4.324-4.265-4.324h-4.13c-2.351 0-4.264 1.94-4.264 4.325v9.7h-4.223c-.94 0-1.705-.774-1.705-1.724V20.07c-.002-.774-.622-1.404-1.382-1.404-.76 0-1.382.63-1.384 1.403v17.606C5.976 40.06 7.89 42 10.241 42h7.194V29.7c0-.949.765-1.72 1.705-1.72h3.72c.94 0 1.703.771 1.703 1.72V42h7.196c2.35 0 4.265-1.94 4.265-4.324V20.067c-.006-.771-.626-1.4-1.384-1.4z"></path>
    </svg>
  );
}

export default HomeSVG;